
import './Ujab_write.scss';
import * as S from '../scss/theme';
import fnc from '../mymod/commFunction';
import fncS4 from '../mymod/commFunction4';
import HongButton from '../comm/HongButton';
import React, { useState, useRef, useMemo, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import HeaderTitle from '../comm/HeaderTitle';
import HongComboboxNew from '../comm/HongComboboxNew';
import JoditEditor from 'jodit-react';
import HongInput from '../comm/HongInput';
import Ujab_detail_download from './Ujab_detail_download';
import { setSelectedParentCode_ujab } from "../reduxToolkit/reduxIgong";


const Ujab_write = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const selectedParentCode_ujab = useSelector(state => state.reduxIgong.selectedParentCode_ujab);

  const [listUnit1, setListUnit1] = useState([]);
  const [listUnit2, setListUnit2] = useState([]);
  const [title, setTitle] = useState('알쓸우잡 입력');
  const editor = useRef(null);
  const [content, setContent] = useState(''); // JoditEditor의 내용 상태
  const [subject, setSubject] = useState(''); // 주제 입력 상태
  const [writer, setWriter] = useState('');
  const [hp, setHp] = useState('');
  const [email, setEmail] = useState('');
  const [career, setCareer] = useState('');

  const [files, setFiles] = useState({});
  const [fileNames, setFileNames] = useState({});
  const [parentCode, setParentCode] = useState(null);
  const [selectedUnit1, setSelectedUnit1] = useState(null);
  const [selectedUnit2, setSelectedUnit2] = useState(null);
  const [boardList, setBoardList] = useState([]);
  const [fileCnt, setFileCnt] = useState(0); // 파일 개수 상태
  const [placeholder, setPlaceholder] = useState(''); 


  useEffect(() => {

    if (selectedParentCode_ujab) {//코드 있음(수정)
        fncSelect_list_unit1(() => {
            fncSelectBoardList(selectedParentCode_ujab);
        });
       
         setParentCode(selectedParentCode_ujab);

    } else {//추가

      const pcode = fnc.fncSirialNum('p');//여기서 코드 발급
      setParentCode(pcode);

      fncSelect_list_unit1();   
      

    }

  }, []);


//--------------------------------수정모드

  function fncSelectBoardList(code) {
    fnc.sendAxios('/igongUjabRoutes/select/board_detail', {code}, (res) => {

      if (res && Array.isArray(res)) {
        setSubject(res[0].subject);
        setWriter(res[0].writer);
        setContent(res[0].content);
        setHp(res[0].hp);
        setEmail(res[0].email);
        setCareer(res[0].career);

        const unit1_code = res[0].unit1_code;
        setSelectedUnit1(unit1_code);

        fncSelect_list_unit2(unit1_code, () => {
          setSelectedUnit2(res[0].unit2_code)
        });

      } else {
        setBoardList([]);
      }
    });
  }

  //------------------------------------------------------

  function fncSelect_list_unit1(callback) {
    fnc.sendAxios('/ujabRoutes/select/unit1', { }, (res) => {
      if (res && Array.isArray(res)) {
        const newList = getRecords(res);
        setListUnit1(newList);
        callback();
      } else {
        alert('검색에 실패했습니다.');
      }
    });
  
    function getRecords(res) {
      return res.map(item => ({
        value: item["unit1_code"] ?? '',
        label: item["unit1_name"] ?? '',
        no: item["sort_order"] ?? ''
      }));
    }
  }

  function handleUnit1Change(selectedValue, selectedLabel, selectedItem) {
    if (selectedValue) {
      setSelectedUnit1(selectedValue);
      fncSelect_list_unit2(selectedValue);
    }
  }

  function fncSelect_list_unit2(unit1_code, callback) {
    fnc.sendAxios('/ujabRoutes/select/unit2', {unit1_code}, (res) => {
      if (res && Array.isArray(res)) {
        const newList = getRecords(res);
        setListUnit2(newList);
        callback();
      } else {
        alert('검색에 실패했습니다.');
      }
    });

    function getRecords(res) {
      return res.map(item => ({
        value: item["unit2_code"] ?? '',
        label: item["unit2_name"] ?? '',
        no: item["sort_order"] ?? ''
      }));
    }
  }

  function handleUnit2Change(selectedValue, selectedLabel, selectedItem) {
    if (selectedValue) {
      setSelectedUnit2(selectedValue);
    }
  }

// JoditEditor 설정


    const config = useMemo(
        () => ({
            readonly: false, // Jodit의 모든 옵션은 https://xdsoft.net/jodit/docs/ 에서 확인할 수 있습니다.
            placeholder: placeholder || '',
            uploader: {
                insertImageAsBase64URI: true,
                imagesExtensions: ["jpg", "png", "jpeg", "gif"],
            },
            dragAndDrop: false, // 드래그 앤 드롭을 활성화합니다.
            askBeforePasteHTML: false,
            askBeforePasteFromWord: false,
            defaultActionOnPaste: "insert_clear_html",
            // toolbar: false, // 툴바를 숨깁니다
            statusbar: false,
            colorPickerDefaultTab: "text", // 기본 탭을 텍스트로 설정
            style: {
              textAlign: 'left', // 기본 텍스트 왼쪽 정렬
          },
            
        }),
        [placeholder]
    );

    
    //----------------------------------------------------------------------등록
      function validateForm() {
        if (!selectedUnit1) {
          alert('구분1을 선택하세요.');
          return false;
        }
        if (!selectedUnit2) {
          alert('구분2를 선택하세요.');
          return false;
        }
        if (!subject.trim()) {
          alert('주제를 입력하세요.');
          return false;
        }
        if (!content.trim()) {
          alert('내용을 입력하세요.');
          return false;
        }
        if (!writer.trim()) {
          alert('글쓴이를 입력하세요.');
          return false;
        }
        if (!hp.trim()) {
          alert('연락처를 입력하세요.');
          return false;
        }
        if (!email.trim()) {
          alert('E-mail을 입력하세요.');
          return false;
        }
        // 이메일 형식 검사 추가
        const emailPattern = /\S+@\S+\.\S+/;
        if (!emailPattern.test(email)) {
          alert('유효한 이메일 주소를 입력해 주세요.');
          return false;
        }
   
        if (!career.trim()) {
          alert('이력을 입력하세요.');
          return false;
        }
        return true;
      }


      function fncInsertBoard() {
      if (!validateForm()) return;
    
      const rtn = window.confirm('게시물을 등록하시겠습니까?');
      if (!rtn) return;

      fnc.sendAxios('/igongUjabRoutes/insert/board', {
        unit1_code: selectedUnit1, // 선택된 구분1 코드
        unit2_code: selectedUnit2, // 선택된 구분2 코드
        subject,
        content,
        writer,
        hp,
        code: parentCode,
        email,
        career,
        }, (res) => {

        if (!res) {
          alert('등록에 실패했습니다.');
          return;
        }
        if (res.success === true) {
           if (files.ujab1) {
              fncUploadAll();
           } else {
              alert('완료되었습니다.');
              onBackClick(); // 등록 후 뒤로가기
           }
        } else {
          alert('등록에 실패했습니다.');}
        });
    }

    
//-----------------------------------------------------파일 업로드


  function fncUploadAll() {
    if (files.ujab1) {
        handleUpload(files.ujab1, 'ujab1','F01');//'F01' 의미 없음
    }
  }



  const handleFileChange = (e) => {
    const name = e.target.name;
    const inputFiles = e.target.files;//파일을 한개만 선택하니까 inputFiles[0]

    if (inputFiles.length > 0 && inputFiles[0]) {
      setFiles(prev => ({ ...prev, [name]: inputFiles[0] }));
      setFileNames(prev => ({ ...prev, [name]: inputFiles[0].name }));
    } else {
      // 파일 선택 취소 시 해당 항목 제거
      setFiles(prev => {
        const newFiles = { ...prev };
        delete newFiles[name];
        return newFiles;
      });
      setFileNames(prev => {
        const newNames = { ...prev };
        delete newNames[name];
        return newNames;
      });
    }
  };


  
  const handleUpload = async (file, filePrefix, titleCode) => {
    try {
      const expireSec = 600; // presigned URL 유효시간 (초)
      const fileCode = fnc.getSafeFileName(file.name, filePrefix);
      const folder = 'upload/ujab'; // S3에 업로드할 폴더 경로
      const orgFileName = file.name;
  
      fnc.sendAxios('/generate-upload-url', {fileName: fileCode, fileType: file.type,
        folder: folder, sec: expireSec}, (presignedRes) => {
        if (presignedRes) {
            const { url, key } = presignedRes; 
            fncS4.axiosPutFile(url, file); // 2. presigned URL로 S3에 직접 파일 PUT
           
            fncInsertUploadRecord( parentCode, fileCode, orgFileName, titleCode);
          } else {
            console.log('Error during file download');
          }    
        }); 
       
    } catch (err) {
      console.error('업로드 중 오류 발생:', err);
      alert('오류가 발생했습니다.');
    }
  };
  
  
  function fncInsertUploadRecord( parentCode, fileCode, fileName, titleCode) {
    const code = fnc.fncSirialNum('c');
    const extension = fileName.split('.').pop();
    const kind = extension;
  
    fnc.sendAxios(`/igongUjabRoutes/insert/board/uploadRecord`, {
      parentCode, fileCode, fileName, code, kind, titleCode }, (res) => {
      if (res) {
        alert('완료되었습니다.');
        onBackClick();
      } else {
        console.log('uploadRecord 저장 중 오류');
      }
    });
  }


  function onSave() {
    fncInsertBoard();
  }

  function onBackClick() {
  
    if (selectedParentCode_ujab) {
       navigate('/ujab_detail'); 
    } else {
        navigate('/ujab_board'); 
    }
   
  }
  
    
//=========================================
  return (
  <S.Section2>
   
    <div className='Ujab_write'>
      <section className='sec-main'>
      <HeaderTitle title='알쓸우잡 추가 및 수정' direction={1} onBackClick={onBackClick} />
      <article className='art-unit1'>
        <div className='box-unit1'>
          <HongComboboxNew
            className='h-combobox'
            label=''
            options={listUnit1}
            value={selectedUnit1}
            onChange={handleUnit1Change} 
            placeholder='구분1을 선택하세요.'/>
          
        </div>

        <div className='box-unit2'>
          <HongComboboxNew
            className='h-combobox'
            label=''
            options={listUnit2}
            value={selectedUnit2}
            onChange={handleUnit2Change}
            placeholder='구분2를 선택하세요.'
          />
        </div>

      </article>

      <article className='art-subject'>
        <div className='box-subject'>
          <HongInput
            className='input-subject'
            label=''
            value={subject}
            onChange={e => setSubject(e.target.value)}
            placeholder='주제를 입력하세요.'
          />
        </div>
      </article>

      <article className='art-jodit'>
          <JoditEditor
              ref={editor}
              value={content}
              config={config}
              tabIndex={1} // 텍스트 영역의 tabIndex
              // onBlur={newContent => setQue(newContent)} // 죽여야 닫기 할 때 에러 안 남
              onChange={newContent =>setContent(newContent)}
          />
      </article>

      <article className='art-fileDownload'>
        <Ujab_detail_download parentCode={selectedParentCode_ujab} setFileCnt={setFileCnt} isVisible={true} />    
      </article>

      <article className='art-info'>
        <div className='box-info'>
          <label className='label-info'>*글쓴이</label>
          <HongInput
            className='input-info'
            label=''
            value={writer}
            onChange={e => setWriter(e.target.value)}
            // placeholder='글쓴이를 입력하세요.'
          />
        </div>

        <div className='box-info'>
          <label className='label-info'>*연락처</label>
           <HongInput
            className='input-info'
            label=''
            value={hp}
            onChange={e => setHp(e.target.value)}
            // placeholder='연락처를 입력하세요.'
          />
        </div>

          <div className='box-info'>
            <label className='label-info'>*E-mail</label>
            <HongInput
              className='input-info'
              label=''
              value={email}
              onChange={e => setEmail(e.target.value)}
              // placeholder='E-mail을 입력하세요.'
            />
          </div>

          <div className='box-info'>
            <label className='label-info'>*이력</label>

            <HongInput
              className='input-info'
              label=''
              value={career}
              onChange={e => setCareer(e.target.value)}
              // placeholder='이력을 입력하세요.'
            />
        </div>
      </article>

      <article className='art-fileUpload'>
        <div className="upload-row">
          {/* <label>첨부파일</label> */}
          <input type="file" name="ujab1" accept="*" onChange={handleFileChange} />
        </div>
      </article>

      <article className='art-menu'>
            <HongButton className='btn h-btn-gray' onClick={() => onBackClick()}>목록으로</HongButton>
            <HongButton className='btn h-btn-red' onClick={onSave}>저장</HongButton>
      </article>
      
    </section>
    </div>
  </S.Section2>
  );
};

export default Ujab_write;